var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaxg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.862 26.748a11.365 11.365 0 0 1-1.783-2.916h-.001c-2.598-3.268-2.428-8.577.13-13.572-2.559 4.996-2.732 10.304-.147 13.572a11.48 11.48 0 0 0 1.783 2.916c-5.274-.85-8.815-3.57-5.65-10.71.831-1.86 1.19-3.711 1.516-5.385.757-3.9 1.327-6.831 7.233-6.642-.489.457-1 .993-1.557 1.623.56-.63 1.073-1.15 1.578-1.614l.504.024c1.802.108 3.566.353 5.2.777-1.634-.426-3.403-.676-5.217-.784l-.504-.02c2.323-2.163 5.006-2.854 8.064-.73C21.11 4.75 23.28 5.117 25.896 5.56c.481.081.977.165 1.49.26 3.004.55 3.646 3.59 2.271 7.464l-.001.004a24.107 24.107 0 0 1-4.26 7.132l-.073.087.073-.087a24.107 24.107 0 0 0 4.26-7.132c2.092 3.523 2.074 7.337-2.457 9.29-3.038 1.309-5 3.095-6.673 4.618-2.774 2.524-4.751 4.324-9.512 2.022a9.64 9.64 0 0 1-3.153-2.47zM16.864 6.02a12.347 12.347 0 0 1 3.354.14h-.001a12.337 12.337 0 0 0-3.353-.14zm12.793 7.264-.054-.085.054.084zM13.761 23.815a7.89 7.89 0 0 0 5.924-1.075c3.654-2.337 4.15-6.89 2.346-10.83-1.85-4.046-6.924-5.154-10.881-2.342-3.538 2.5-4.704 7.195-2.346 10.831a7.89 7.89 0 0 0 4.957 3.415z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxg);
export default __webpack_public_path__ + "static/media/PAXG.774deea9355f3743f353d68a1c35d38f.svg";
export { ForwardRef as ReactComponent };